<template>
    <div>
        <div v-if="!chat_visible && !authenticated">
            <div class="row">
                <div class="col-xs-12">
                    <button @click="openGuestFormModal()" type="button" id="mbl_bt_message" class="btn btn btn-block btn-success waves-effect waves-light"><i class="fas fa-envelope text-white m-r-5"></i> Falar com {{ user.full_name }} </button>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="row" v-if="!message">
                <div class="p-0" :class="{'col-xs-12': credits_balance < view_phone_amount, 'col-xs-9': credits_balance >= view_phone_amount}">
                    <button @click="openHostMessageModal()" class="btn btn btn-block btn-success waves-effect waves-light">Falar com Anunciante</button>
                </div>
                <div class="col-xs-3 p-0" v-if="credits_balance >= view_phone_amount">
                    <button @click="openPhoneModal()" id="mbl_btn_contact_phone" class="btn btn btn-block btn-custom waves-effect waves-light"><i class="fas fa-phone"></i></button>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-xs-12">
                    <a :href="'/mensagens/' + user.id" id="mbl_bt_message" class="btn btn btn-block btn-custom waves-effect waves-light"><i class="fas fa-envelope text-white m-r-5"></i> Ver conversa com {{ user.first_name }} </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CtaForm from '../invitation-form/mobile-cta-form.vue';
    import GuestLeadForm from '../invitation-form/guest-lead-form.vue';
    export default {
        components: { CtaForm, GuestLeadForm },
        props: [
            'type',
            'online',
            'message_sent',
            'fk_property',
            'location_object',
            'proommate',
            'authenticated',
            'pinvitation',
            'rent_price',
            'ic_amount',
            'cta_url',
            'user',
            'chat_visible',
            'credits_balance',
            'view_phone_amount'
        ],
        data() {
            return {
                message: this.message_sent,
                roommate: this.proommate,
            }
        },
        computed: {
            fk_roommate() {
                return (this.roommate != false ? this.roommate.id : null);
            },
        },
        created () {
            let _this = this;
            EventBus.$on('update-message-sent', function() {
                _this.message = true;
            });

            EventBus.$on('message_sent', () => {
                _this.message = true;
            });

            EventBus.$on('roommate_ad_created', (res) => {
                this.roommate = res.roommate_ad
            });

            EventBus.$on('view-mobile-invitation-form', () => {
                this.showHostInvitationForm();
            });
        },
        methods: {
            openPhoneModal() {
                if (!this.authenticated) {
                    EventBus.$emit('open-modal', 'register-modal');
                    window.dataLayer.push({
                        'event': 'show_login_modal',
                        'event_category': 'property_ad_page',
                        'event_label': 'show_phone',
                    });
                    return false;
                }

                EventBus.$emit('open-modal', 'phone-block-modal', {
                    name: this.user.first_name,
                    type: 'property_ad_page',
                    fk_user: this.user.id
                })
            },
            openGuestFormModal() {
                EventBus.$emit('open-modal', GuestLeadForm, {
                    cta_url: this.cta_url,
                    user: this.user,
                    fk_property_ad: this.fk_property,
                    authenticated: this.authenticated,
                    chat_visible: this.chat_visible,
                    class: 'modal-content sm-padding'
                });
            },
            openHostMessageModal() {
                if (!this.authenticated) {
                    EventBus.$emit('open-modal', 'register-modal');
                    window.dataLayer.push({
                        'event': 'show_login_modal',
                        'event_category': 'property_ad_page',
                        'event_label': 'send_message',
                    });
                    return false;
                }

                if (this.cta_url != '') {
                    EventBus.$emit('open-modal', CtaForm, {
                        cta_url: this.cta_url,
                        user: this.user,
                        fk_property_ad: this.fk_property,
                        authenticated: this.authenticated,
                        chat_visible: this.chat_visible
                    });
                    return;
                }

                this.showHostInvitationForm();
            },
            showHostInvitationForm() {
                if (!this.roommate) {
                    EventBus.$emit('open-modal', 'roommate-modal-form', {
                        backdrop: 'static',
                        location: this.location_object,
                        rent_price: this.rent_price}
                    );
                    window.dataLayer.push({
                        'event': 'show_roommate_form',
                        'event_category': 'property_ad_page',
                        'event_label': 'send_message',
                    });
                    return false;
                }

                if (this.message_sent)
                    return;

                EventBus.$emit('open-modal', 'mobile-invitation-form', {
                    name: this.user.first_name,
                    photo: this.user.photo_url,
                    fk_user: this.user.id,
                    online: this.online,
                    fk_property: this.fk_property,
                    proommate: this.roommate,
                    response_rate: this.user.response_rate,
                    last_activity: this.user.last_activity,
                    verified: this.user.verified_account,
                    authenticated: this.authenticated,
                    location_object:  this.location_object,
                    rent_price: this.rent_price
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mbl_btn_contact_phone {
        padding-right: 25%;
    }
</style>
